<template lang="pug">
.sideload-frame(style="width: 500px")
  .sideload-header.px-5.pt-5.pb-4.border-bottom.d-flex.justify-content-between
    pr-subtitle(weight="semibold", size="medium") 
      |
      span {{ $t("Bill View") }}
    icon.fa-2x(type="flat-icon", icon="flaticon-invoices")
  .sideload-notification.text-center
    .sideload-message.py-3.px-5.border-bottom.alert.m-0(v-if="message", :class="[message.class]")
      icon.mr-3(:icon="message.icon", :class="{ 'fa-spin': message.icon === 'far spinner' }")
      | {{ message.content }}
    pr-button.themed.m-0.mt-5(small, v-nv.current, v-show="!state", @nv-enter="$emit('close')") {{ $t("Close") }}
  .sideload-body.flex-grow-1(v-show="state", nv-el, @nv-up="scroll", @nv-down="scroll", ref="scrollArea")
    .scroll-container
      billItem(v-for="item in items", :item="item", :key="item.order")
  .sideload-footer.px-5.pb-4.pt-4.border-top(v-show="state===1")
    pr-text(size="medium") 
      |
      span.text-muted {{ $t("Total Amount") }} :
      strong.ml-3 {{ $t("currency", [this.total]) }}
</template>

<script>
import billItem from "./bill-item.vue"
export default {
  name: "billview",
  components: { billItem },
  data() {
    return {
      message: {
        icon: "far spinner",
        class: "alert-warning",
        content: this.$t("Your billing information is fetching...")
      },
      state: 0,
      items: [],
      total: 0
    }
  },
  async mounted() {
    this.$emit("ready")

    _$.nav.sync("sideload", true)
    this.$refs.scrollArea.scrollTop = 0

    const { pms_id } = __.guest.get() || {}
    if (!pms_id) return this.makeMessage(this.$t("You aren't authorized to view this section."))

    const res = await __.api.get.billview({ guest_pms_id: pms_id, type: "request" })
    if (!res || res.errCode === 301) return this.makeMessage()

    this.getBillView(pms_id)
  },
  methods: {
    async getBillView(pms_id) {
      if (this._isDestroyed) return

      const res = await __.api.get.billview({ guest_pms_id: pms_id, type: "response" })
      if (!res || res.errCode === 100) return this.makeMessage()
      else if (res.errCode === 401) return this.makeMessage(this.$t("Bill view request timed out."))
      else if (res.errCode === 402) return _$.sleep(10000).then(() => this.getBillView(pms_id))
      else if (!res.status) return this.makeMessage()

      if (!res.data.items.length) return this.makeMessage(this.$t("You don't have bill activities yet."), "warning")

      res.data.items.forEach(item => {
        item.date = item.date
          .split("-")
          .reverse()
          .join("-")
        item.time = item.time.split(":")
        item.date = new Date(item.date)
        item.date.setHours(item.time.shift(), item.time.shift())
      })
      res.data.items.reverse()

      this.items = res.data.items
      this.total = res.data.total
      this.message = false
      await this.$nextTick()
      this.state = 1
      await this.$nextTick()
      _$.nav.refreshScope("sideload")
    },
    makeMessage(message, type = "danger") {
      this.message = {
        icon: type === "success" ? "far check-square" : "far exclamation-triangle",
        class: "alert-" + type,
        content: message || "Unknown error!"
      }
      return type === "danger" ? false : true
    },
    scroll($event, toTop = false) {
      let scrollTop = this.$refs.scrollArea.scrollTop
      switch ($event.type) {
        case "nv-down":
          scrollTop += 100
          break
        case "nv-up":
          scrollTop -= 100
          break
      }
      if (toTop) scrollTop = 0
      $(this.$refs.scrollArea).animate({ scrollTop: scrollTop }, 200)
    }
  }
}
</script>

<style lang="scss">
.sideload-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
  .sideload-message {
    border-radius: 0 !important;
  }
  .sideload-body {
    overflow: auto;
    position: relative;

    .scroll-container {
      position: relative;
    }
  }
}
</style>
